// Sidechain is only needed once an iframe block renders, so we load it on
// demand. It lives in its own module so specs can control when the load
// settles, which a bare dynamic import doesn't allow.
export const loadSidechain = () => import("@nprapps/sidechain")
